import type {Mapper} from 'framework';
import type {AssistantAttachment} from '../../domain/assistant-attachment';
import type {AssistantAttachmentDto} from '../dto/assistant.dto';

export class AssistantAttachmentDtoToAssistantAttachmentMapper implements Mapper<
  AssistantAttachmentDto,
  AssistantAttachment
> {
  transform(dto: AssistantAttachmentDto): AssistantAttachment {
    return {
      id: dto.id,
      imageUrl: dto.imageUrl,
      thumbnailUrl: dto.thumbnailUrl,
      mimeType: dto.mimeType,
      byteSize: dto.byteSize,
    };
  }
}
